import { useLocation, Link } from "react-router-dom";
import { useEffect } from "react";
import { Helmet } from "react-helmet-async";

const NotFound = () => {
  const location = useLocation();

  useEffect(() => {
    console.error("404 Error: User attempted to access non-existent route:", location.pathname);
  }, [location.pathname]);

  return (
    <>
      <Helmet>
        <title>Sidan hittades inte – Korthet</title>
        <meta name="robots" content="noindex, nofollow" />
        <meta name="description" content="Sidan du letar efter kunde inte hittas. Den kanske har flyttats eller tagits bort." />
        <link rel="canonical" href="https://korthet.se" />
      </Helmet>
      
      <div className="min-h-screen bg-background">
        {/* Simple header with site branding */}
        <header className="border-b border-border bg-background/95 backdrop-blur">
          <div className="mx-auto max-w-7xl px-4 py-4">
            <div className="flex flex-col items-center justify-center">
              <h1 className="text-2xl font-bold text-foreground">
                <Link to="/" className="hover:text-primary transition-colors">
                  Nyheter i Korthet
                </Link>
              </h1>
              <p className="text-sm text-muted-foreground">Kortare nyheter. Större perspektiv.</p>
            </div>
          </div>
        </header>

        {/* 404 content */}
        <div className="flex min-h-[calc(100vh-80px)] items-center justify-center">
          <div className="text-center px-4">
            <h2 className="mb-4 text-8xl font-bold text-destructive">404</h2>
            <p className="mb-2 text-2xl font-semibold text-foreground">Sidan kunde inte hittas</p>
            <p className="mb-6 text-muted-foreground">Den här sidan verkar inte finnas eller har aldrig existerat.</p>
            <Link 
              to="/" 
              className="inline-block rounded-md bg-primary px-6 py-3 text-primary-foreground font-medium transition-colors hover:bg-primary/90"
            >
              Tillbaka till startsidan
            </Link>
          </div>
        </div>
      </div>
    </>
  );
};

export default NotFound;
